export default "__VITE_ASSET__GQMOxZ3W__"